// src/services/analyticsService.js
import axiosInstance from './axiosServicesVisit';
import { API } from '../config/api'; // On a besoin de API pour la version

// Retirez la ligne 'buildAnalyticsUrl', elle n'est pas utilisée et cause un warning.
// const buildAnalyticsUrl = (path) => `${API_URL}${path}`;

// Fonction pour récupérer la liste des délégués (si vous l'utilisez)
export const getDelegatesForAnalytics = () => {
    const versionPrefix = API?.VERSION || 'v1';
    const endpoint = `/${versionPrefix}/analytics/delegates-list`;
    return axiosInstance.get(endpoint);
};

// Fonction existante (déjà correcte)
export const getPhysicianReturnIndexForDelegate = (delegateId, queryParams = {}) => {
    if (!delegateId) {
        return Promise.reject(new Error("L'ID du délégué est requis."));
    }
    const versionPrefix = API?.VERSION || 'v1';
    const endpoint = `/${versionPrefix}/analytics/delegates/${delegateId}/physician-return-index`;
    
    console.log('[AnalyticsService] Appel API GET avec axiosInstance:', endpoint, 'avec params:', queryParams);
    return axiosInstance.get(endpoint, { params: queryParams });
};

// Fonction d'export CORRIGÉE
export const exportPhysicianReturnIndex = (delegateId, queryParams = {}) => {
    if (!delegateId) {
        return Promise.reject(new Error("L'ID du délégué est requis pour l'export."));
    }
    
    // --- DÉBUT DE LA CORRECTION ---
    // On réutilise la même logique de préfixe de version
    const versionPrefix = API?.VERSION || 'v1';
    const endpoint = `/${versionPrefix}/analytics/delegates/${delegateId}/physician-return-index/export`;
    // --- FIN DE LA CORRECTION ---
    
    console.log('[AnalyticsService] Appel API EXPORT avec axiosInstance:', endpoint, 'avec params:', queryParams);
    return axiosInstance.get(endpoint, {
        params: queryParams,
        responseType: 'blob',
    });
};

export const getWeeklyMissedVisits = (delegateId, startDate, endDate) => {
    const params = {};
    if (startDate) params.startDate = startDate;
    if (endDate) params.endDate = endDate;
    
    return axiosInstance.get(`/v1/analytics/delegates/${delegateId}/weekly-missed-visits`, { params });
};